export interface CountryMap {
  id: string
  name: string
  code: string
}

export enum VendorStatus {
  unverified = 'unverified',
  verified = 'verified',
  disabled = 'disabled'
}

export interface Vendor {
  name: string
  email: string
  bio: string
  phonenumber: string
  logoUrl: string
  originCountry?: CountryMap
  status: VendorStatus
}

export const vendorConverter: firebase.firestore.FirestoreDataConverter<Vendor> = {
  toFirestore: vendor => {
    return {
      name: vendor.name,
      email: vendor.email,
      bio: vendor.bio,
      phonenumber: vendor.phonenumber,
      logoUrl: vendor.logoUrl,
      originCountry: vendor.originCountry,
      status: vendor.status
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      name: data.name,
      email: data.email,
      bio: data.bio,
      phonenumber: data.phonenumber,
      logoUrl: data.logoUrl,
      originCountry: data.originCountry,
      status: data.status
    }
  }
}
